import { render, staticRenderFns } from "./ReservationPopup.vue?vue&type=template&id=a88c40f4&scoped=true&"
import script from "./ReservationPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPopup.vue?vue&type=style&index=0&id=a88c40f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88c40f4",
  null
  
)

export default component.exports